import {Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {ProductListing} from "../../raintree/interface/product-listing/product-listing";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {SearchTransmissionService} from "../../raintree/transmission/search-transmission.service";
import {PrepareSearchDataService} from "../../services/prepare-search-data.service";
import {ProductListPriceCalculationService} from "../../product/service/product-list-price-calculation.service";
import {RequestMapperService} from "../../request-mapper.service";
import {ProductPreview} from "../../product/product-listing/interface/product-preview";
import {SearchComponent} from "../search/search.component";
import {NavigationExtras, Router} from "@angular/router";
import {BloomsightService} from "../../bloomsight.service";
import {isPlatformBrowser} from "@angular/common";

@Component({
	selector: 'fb-search-results',
	templateUrl: './search-results.component.html',
	styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit, OnDestroy {

	public products: ProductListing[] = [];
	public productListingForView: ProductListing[] = [];
	public loading: boolean = false;
	public timer: any;
	public pageLength: number = 31;
	public pageNumber: number = 1;
	public pageNumberURL: number = 1;
	public pageStartIndex: number = 0;
	public pageEndIndex: number = this.pageNumber * this.pageLength - 1;
	public isBrowser: boolean = false;
	public isLoadMoreScrolledIntoView: boolean = false;


	public searchFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(3)
	]);

	public searchFormGroup: FormGroup = new FormGroup({
		search: this.searchFormControl
	});


	@ViewChild('testDiv', { static: false })
	private testDiv: ElementRef<HTMLDivElement> =
		{} as ElementRef<HTMLDivElement>;

	constructor(
		private _router: Router,
		private _api: SearchTransmissionService,
		private _searchService: PrepareSearchDataService,
		private _preparePricing: ProductListPriceCalculationService,
		private _bloomsight: BloomsightService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	ngOnInit() {
		this.searchFormControl.setValue(this._searchService.prepareSearchParam());

		if (this.searchFormControl.value) {
			this.searchFormControl.markAsDirty();
			this._getResults();
		}
	}

	private _getResults(): void {
		this._api.getSearchResult(
			RequestMapperService.SEARCH + this.searchFormControl.value,
			() => {
				this.loading = true;
				this.products = [];
				this.productListingForView = [];
				this._bloomsight.trackDataEvent(
					'65a91134adae2d98edc6c5c2',
					{searchKey: this.searchFormControl.value},
					''
				);
			},
			(response) => {
			},
			(response: ProductPreview[]) => {
				this.products = this._searchService.prepareSearchData(response);
				this.products = this._preparePricing.calculateListingPriceForFinishedProduct(this.products);
				this.loadMore();
			},
			(error: string) => {
			},
			() => this.loading = false
		);
	}

	public getFilteredProducts(): void {

		clearTimeout(this.timer);

		this.timer = setTimeout(() => {
			if (!this.searchFormControl.valid) {
				return;
			}
			const navigationExtras: NavigationExtras = {
				queryParams: {search: this.searchFormControl.value},
				queryParamsHandling: 'merge',
			};

			this._router.navigate([
				RequestMapperService.SEARCH_RESULTS_URL,
				RequestMapperService.SEARCH_URL
			], navigationExtras).then(
				() => {
					this.products = [];
					this._getResults();
				}
			);
		}, SearchComponent.waitTime);
	}

	public onSubmit(): void {
		this.getFilteredProducts();
	}

	public loadMore(): void {
		if(this.products.length > this.pageLength) {
			this.productListingForView = [
				...this.productListingForView,
				...this.products.slice(this.pageStartIndex, this.pageEndIndex),
			];
		}
		else {
			this.productListingForView = this.products;
		}
	}

	public loadMoreClicked(): void {
		this.pageNumber += 1;
		this.pageStartIndex =
			(this.pageNumber - 1) * this.pageLength;
		this.pageEndIndex = this.pageStartIndex + this.pageLength;

		this.loadMore();
	}

	@HostListener('window:scroll', ['$event'])
	public isScrolledIntoView(): void {
		if (this.testDiv ) {
			if(this.isBrowser){
				const rect:DOMRect = this.testDiv.nativeElement.getBoundingClientRect();
				const topShown: boolean = rect.top >= 0;
				const bottomShown: boolean = rect.bottom <= window.innerHeight;
				this.isLoadMoreScrolledIntoView = topShown && bottomShown;
			}


			if (this.isLoadMoreScrolledIntoView) {
				this.loadMoreClicked();
			}
		}
	}

	ngOnDestroy(): void {
		this._searchService.unSubscribe();
	}

}
